import {
  faArrowLeft,
  faArrowRight,
  faBars,
  faBell,
  faBiking,
  faCar,
  faCog,
  faHeart,
  faInfoCircle,
  faLink,
  faPowerOff,
  faShoppingBag,
  faShoppingCart,
  faStar, faStoreAlt, faUser,
  faUtensils
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component, createRef } from 'react';
import { Parallax } from 'react-parallax';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { alerts } from '../../actions/Alerts';
import { updateCart } from '../../actions/Cart';
import { getCategories } from '../../actions/Categories';
import MenuCart from '../cart/MenuCart';

import {
  getLocation,
  getLocationLayoutSettings,
  getOutlets,
  setLocation
} from '../../actions/Locations';
import { getLoyalties } from '../../actions/Loyalties';
import { getNotifications } from '../../actions/Notifications';
import { getPaymentProcessor } from '../../actions/Payments';
import { getPromotions } from '../../actions/Promotions';
import '../../assets/css/parallax.scss';
import CONSTANTS from '../../constants';
import ImageHelper from '../../helpers/ImageHelper';
import NotificationHelper from '../../helpers/NotificationHelper';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';
import TimeHelper from '../../helpers/TimeHelper';
import ViewHelper from '../../helpers/ViewHelper';
import CartService from '../../services/CartService';
import LoginService from '../../services/LoginService';
import UserLocationService from '../../services/UserLocationService';
import CustomLogin from '../sessions/CustomLogin';
import withBackButtonHandled from '../shared/WithBackButtonHandled';
import OutletInformation from '../top-menu/outlet-information';


const LogoutIcon = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_221"
            data-name="Rectangle 221"
            width="14"
            height="14"
            fill={color.color}
          />
        </clipPath>
      </defs>
      <g id="Mask_Group_23" data-name="Mask Group 23" clip-path="url(#clip-path)">
        <g id="switch" transform="translate(0.589)">
          <path
            id="Path_170"
            data-name="Path 170"
            d="M7,14A6.417,6.417,0,0,0,9.567,1.705.583.583,0,1,0,9.1,2.774a5.25,5.25,0,1,1-4.2,0,.583.583,0,1,0-.467-1.069A6.417,6.417,0,0,0,7,14Z"
            transform="translate(-0.589)"
            fill={color.color}
          />
          <path
            id="Path_171"
            data-name="Path 171"
            d="M7,5.833a.583.583,0,0,0,.583-.583V.583a.583.583,0,1,0-1.167,0V5.25A.583.583,0,0,0,7,5.833Z"
            transform="translate(-0.589)"
            fill={color.color}
          />
        </g>
      </g>
    </svg>
  );
};

class Banner extends Component {
  constructor(props) {
    super(props);
    this.sidebarRef = createRef();
    this.cartRef = createRef();
    this.notificationRef = createRef();
    this.state = { showLoginModal: false, showOrderPref: false, orderData: null };
  }

  changeLayout(type) {
    this.props.setLayout(type);
  }

  async trackEvent(eventName, eventData) {
    try {
      if (window.clarity && typeof window.clarity.apply === 'function') {
        window.clarity('set', eventName, eventData.page);
      } else {
        console.warn('Clarity object is not defined or has no apply method.');
      }
    } catch (error) {
      console.error('Error integrating Clarity:', error);
    }
  }

  async toggleLoginModal() {
    this.closeSidebar();
    await this.trackEvent('Login', { page: 'Main Page' });
    this.setState({
      showLoginModal: !this.state.showLoginModal
    });
  }

  getAllowedOrderTypes(outlets) {
    if (!outlets) return {};

    const allowedOrderTypes = {};
    for (let i = 0; i < outlets.length; i++) {
      const out = outlets[i];
      for (let j = 0; j < out.orderTypes.length; j++) {
        allowedOrderTypes[out.orderTypes[j].order_type] = true;
      }
    }
    return allowedOrderTypes;
  }

  togglePrefModal() {
    this.setState({
      ...this.state,
      showOrderPref: !this.state.showOrderPref
    });
  }

  myOrderSidebar() {
    this.props.history.push(`${CONSTANTS.BASE_URL}${this.props._location?.slug}/my-order`);
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = '-100%';
  }
  myRewardSidebar() {
    this.props.history.push(`${CONSTANTS.BASE_URL}${this.props._location?.slug}/loyalty`);
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = '-100%';
  }
  myRewardWalletSidebar() {
    this.props.history.push(`${CONSTANTS.BASE_URL}${this.props._location?.slug}/earned`);
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = '-100%';
  }
  openTerms() {
    this.props.history.push(`${CONSTANTS.BASE_URL}${this.props._location?.slug}/terms`);
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = '-100%';
  }

  openAccModal() {
    this.props.toggleAccModal();
    this.closeSidebar();
    this.closeSidebarOther();
  }



  openSidebar() {
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = '0';
    let overlay = document.getElementById('overlay');
    overlay.classList.add('overlay');
  }

  openCartbar() {
    let sidebarElement = document.getElementsByClassName('cart-sidebar-menu-data');
    sidebarElement[0].style.right = '0';
  }
  closeCartbar() {
    let sidebarElement = document.getElementsByClassName('cart-sidebar-menu-data');
    sidebarElement[0].style.right = '-100%';

  }

  openSidebarOther() {
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data-other');
    sidebarElement[0].style.right = '0';
  }

  closeSidebar() {
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = '-100%';
    let overlay = document.getElementById('overlay');
    overlay.classList.remove('overlay');
  }

  closeSidebarOther() {
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data-other');
    sidebarElement[0].style.right = '-100%';
  }

  showNotification() {
    let notification = document.getElementsByClassName('sidebar-menu-notification-data');
    notification[0].style.right = 0;
  }

  closeNotification() {
    let notification = document.getElementsByClassName('sidebar-menu-notification-data');
    notification[0].style.right = '-100%';
  }

  checkIfClickedOutside(e) {
    if (this.notificationRef.current && this.notificationRef.current.contains(e.target) === false) {
      this.closeNotification();
    }
    if (this.sidebarRef.current && this.sidebarRef.current.contains(e.target) === false) {
      this.closeSidebar();
    }
  }

  async componentDidMount() {
    document.addEventListener('mousedown', this.checkIfClickedOutside.bind(this));

    return () => {
      document.removeEventListener('mousedown', this.checkIfClickedOutside.bind(this));
    };
  }

  onReviewClick(notification) {
    if (NotificationHelper.isOrderReview(notification))
      this.props.history.push(`${CONSTANTS.BASE_URL}${notification.Location.slug}/reviews/new`, {
        order: notification.Order,
        _location: this.props._location,
        location: notification.Location,
        notificationId: notification.not_id,
        locationSettings: this.props.locationSettings
      });
  }

  logOut() {
    let userId = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_userId`);
    LoginService.logout(userId, this.props._location.loc_id);
    LoginService.removeLoginData();
    //this.props.onLogin(false);
    this.props.history.push(`/${this.props._location?.slug}`);
    this.closeSidebar();
  }

  setPromotions() {
    let promises = [];
    promises.push(this.props.getPromotions(this.props._location.slug));
    promises.push(this.props.getLoyalties(this.props._location.slug));
    Promise.all(promises);
  }

  async onLoginCallback(status) {
    if (status) {
      this.setPromotions();
      const locations = await UserLocationService.getSavedLocations();
      if (locations && locations.length > 0) {
        const orderData = CartService.getOrderData(
          this.props._location.orderTypes,
          this.props._location
        );
        if (orderData.selectedOutlet) {
          orderData.selectedLocation = CartService.getMinDistanceLocation(
            locations,
            `${orderData.selectedOutlet.latitude},${orderData.selectedOutlet.longitude}`
          );
        } else if (this.state.geoLocation) {
          orderData.selectedLocation = CartService.getMinDistanceLocation(
            locations,
            this.state.geoLocation
          );
        } else {
          orderData.selectedLocation = locations[0];
        }
        CartService.setOrderData(orderData, this.props._location.orderTypes, this.props._location);
      }
      this.props.onLogin(status);
    }
    this.setState({ isLoggedIn: status }, this.toggleLoginModal.bind(this));
  }

  render() {
    const { _location, outlets, logoImg, banner_classname, width } = this.props;
    let orderData = CartService.getOrderData(_location?.orderTypes, _location);
    const allowedOrderTypes = this.getAllowedOrderTypes(outlets);
    const getFirstChar = (str) => {
      const firstChars = str
        .split(' ')
        .map((word) => word[0])
        .join('');

      return firstChars;
    };
    let checkAsap = OrderTypeHelper.validateAdvAsapTimings(_location, orderData);
    let is_custom_time = localStorage.getItem('is_custom_time');
    const order_time = orderData
      ? orderData.isPickUpNow === 1
        ? 'ASAP'
        : _location?.is_adv_ordering === 1 ? checkAsap ? 'ASAP' : parseInt(is_custom_time) === 0 ? 'Select date & time' : moment(new Date(orderData.order_time)).format(
          CONSTANTS.DATE_TIMES.FORMAT.NEW_DISPLAY
        ) : 'Closed'
      : '-';
    const selected_outlet =
      orderData && orderData.selectedOutlet ? orderData.selectedOutlet.name : _location?.name;

    const order_type_id =
      orderData && orderData?.order_type_id
        ? orderData?.order_type_id
        : allowedOrderTypes['delivery']
          ? _location?.orderTypes?.filter((ot) => ot.order_type === 'delivery')[0]?.id
          : _location?.orderTypes[0]?.id;
    const imageUrl = _location?.img ? `${ImageHelper.getImageURL(`${_location?.img}`, '')}` : null;
    const isReward = localStorage.getItem('isRewardOrder');
    const card_outline = this.props.locationSettings ? this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : '' : '';
    let lineItems = CartService.getLineItems(_location.loc_id);

    if (this.props.grid_layout === 'old') {
      return (
        <React.Fragment>
          {this.props.isOrderingEnabled && (
            <div className="container order-pref-width mt-3">
              <div className="row g-0 justify-content-between">
                <div className="col-lg-7 col-sm-7 col-7">
                  <div className="row g-0" onClick={this.props.toggleModal}>
                    <div className={`col banner-bar-bg-type p-1 text-center f3 highlight-color-active ${card_outline}`}>
                      {OrderTypeHelper.isPickup(this.props.orderTypes, order_type_id) && (
                        <>
                          <FontAwesomeIcon className="" size={'sm'} icon={faShoppingBag} color='var(--highlight-text-color)' />
                          &nbsp; Takeaway
                        </>
                      )}
                      {OrderTypeHelper.isDelivery(this.props.orderTypes, order_type_id) && (
                        <>
                          <FontAwesomeIcon className="" size={'sm'} icon={faBiking} color='var(--highlight-text-color)' />
                          &nbsp; Delivery
                        </>
                      )}
                      {OrderTypeHelper.isDineIn(this.props.orderTypes, order_type_id) && (
                        <>
                          <FontAwesomeIcon className="" size={'sm'} icon={faUtensils} color='var(--highlight-text-color)' />
                          &nbsp; Dine In
                        </>
                      )}
                      {OrderTypeHelper.isCurbsidePickup(this.props.orderTypes, order_type_id) && (
                        <>
                          <FontAwesomeIcon className="" size={'sm'} icon={faCar} color='var(--highlight-text-color)' />
                          &nbsp; Curbside
                        </>
                      )}
                      {order_type_id === null && <>---</>}
                    </div>
                    <div className={`col banner-bar-bg-time p-1 text-center f3 card-color card-font-color ${card_outline}`}>{order_time}</div>
                  </div>
                </div>
                <div className="col-lg-1 col-sm-1 col-1 m-1 text-center">
                  <p className="f-12 header-font-1">From</p>
                </div>
                <div className="col-lg-3 col-sm-3 col-3 ml-2">
                  <div className="row g-0" onClick={this.props.toggleModal}>
                    <div className={`col col-sm-12 banner-bar-bg-type p-1 text-center banner-bar-bg-outlet f3 card-color card-font-color ${card_outline}`}>
                      {order_type_id !== null && (
                        <FontAwesomeIcon className="" size={'sm'} icon={faStoreAlt} />
                      )}
                      &nbsp;
                      {order_type_id !== null ? selected_outlet.toString().substring(0, 8) : '...'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {imageUrl && (
            <Parallax
              className="parallax img-thumbnail rounded"
              bgImage={imageUrl}
              strength={300}
            />
          )}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className={`banner-top-section ${this.props.loc_pathname === 'confirm' || this.props.loc_pathname === 'my-order' || this.props.loc_pathname === 'order-tracker' ? 'bannerborder' : ''} ${banner_classname} ${this.props.isMenu ? '' : card_outline}`}>
            {this.props.main_location == false ||
              (this.props.main_location == null && (
                <div
                  className="go-back-section"
                  onClick={() => {
                    if (ViewHelper.isWebview()) {
                      const connection = window.navigator.onLine;
                      if (connection) {
                        this.props.history !== undefined
                          ? this.props.history.goBack()
                          : this.props.goBack()
                      } else {
                        ViewHelper.showNetworkAlert(this.props._location.name);
                      }
                    } else {
                      this.props.history !== undefined
                        ? this.props.history.goBack()
                        : this.props.goBack()
                      // <<<<<<< HEAD
                      //                     if (ViewHelper.isWebview()) {
                      //                       const connection = window.navigator.onLine;
                      //                       if (connection) {
                      //                         this.props.history !== undefined
                      //                           ? this.props.history.goBack()
                      //                           : this.props.goBack()
                      //                       } else {
                      //                         ViewHelper.showNetworkAlert(this.props._location.name);
                      //                       }
                      //                     } else {
                      //                       this.props.history !== undefined
                      //                         ? this.props.history.goBack()
                      //                         : this.props.goBack()
                      // =======
                      //                     const connection = window.navigator.onLine;
                      //                     if (connection) {
                      //                       this.props.history !== undefined
                      //                         ? this.props.history.goBack()
                      //                         : this.props.goBack()
                      //                     } else {
                      //                       ViewHelper.showNetworkAlert(this.props._location.name);
                      // >>>>>>> cdb4eea198951131009c7eafe977959a3005b81a
                    }
                  }}
                >
                  <div className={`back-img highlight-color card-color hovernowshodow   ${card_outline}`}>
                    <FontAwesomeIcon className="" size={'sm'} icon={faArrowLeft} color='var(--card-subtitle-color)' />
                    {/* <img src={goBack} alt="" /> */}
                  </div>
                  {LoginService.getToken() === null && this.props.loc_pathname === 'confirm' ? (
                    <h2 className={'title card-font-color'}>Sign up or login</h2>
                  ) : (
                    this.props.loc_pathname === 'confirm' && (
                      <h2 className={'title card-font-color'}>{this.props.header_text}</h2>
                    )
                  )}
                  {this.props.loc_pathname !== 'confirm' &&
                    this.props.header_text !== undefined && (
                      <h2 className={'title card-font-color'}>{this.props.header_text}</h2>
                    )}
                </div>
              ))}

            {this.props.main_location === true && logoImg && (
              <div className="logo hovernowshodow">
                <img src={logoImg} alt="" />
              </div>
            )}
            {this.props.main_location === true && !logoImg && (
              <div class="i-circle-logo-main">{getFirstChar(_location.name)}</div>
            )}
            {this.props.main_location === true && (
              <OutletInformation
                windowWidth={width}
                _location={_location}
                order_time={order_time}
                toggleModal={this.props.toggleModal}
                classname={'desktop-outlet'}
                selected_outlet={selected_outlet}
                order_type_id={order_type_id}
                order_type_list={_location.orderTypes}
              />
            )}

            {LoginService.getToken() === null && this.props.loc_pathname === 'confirm' && (
              <OutletInformation
                windowWidth={width}
                _location={_location}
                order_time={order_time}
                toggleModal={this.props.toggleModal}
                classname={'desktop-outlet'}
                selected_outlet={selected_outlet}
                order_type_id={order_type_id}
                order_type_list={_location?.orderTypes}
              />
            )}

            <div className="menu">
              {LoginService.getToken() === null && this.props.main_location === true && (
                <div className="menu__link" onClick={this.toggleLoginModal.bind(this)}>
                  <h3>Login</h3>
                </div>
              )}
              {/*{LoginService.getToken() === null && this.props.loc_pathname !== 'confirm' &&*/}
              {/*<div className="menu__link"*/}
              {/*     onClick={this.toggleLoginModal.bind(this)}*/}
              {/*>*/}
              {/*    <h3>Login</h3>*/}
              {/*</div>}*/}
              {this.props.isCart ?
                <div className={` card-color  card-subtitle-color mt-2`} onClick={this.openCartbar.bind(this)}>
                  <FontAwesomeIcon size={'lg'} icon={faShoppingCart} />
                  <span class="cart-badge start-100 badge rounded-pill bg-danger">
                    {lineItems.length}
                  </span>
                </div>
                : ''}

              <div className={`menu__hamburger card-color hovernowshodow card-subtitle-color ${card_outline}`} onClick={this.openSidebar.bind(this)}>
                <FontAwesomeIcon size={'lg'} color="var(--card-subtitle-color)" icon={faBars} />
              </div>
            </div>
          </div>
          <div className="cart-menu-data" ref={this.cartRef}>
            <div id="overlay" onClick={this.closeSidebar.bind(this)}></div>
            <div className={'cart-sidebar-menu-data card-color'}>
              <div className="hamburger-close__close" onClick={this.closeCartbar.bind(this)}>
                <FontAwesomeIcon size={'lg'} icon={faArrowLeft} color='var(--card-font-color)' />
              </div>
              {
                lineItems.length > 0 && this.props.isCart ? (
                  <div className="cart-list-col">

                    <div className="card p-4 cart-list border-0" >
                      <React.Fragment>
                        <div className='d-flex justify-content-between' >
                          <h2 className="cart-reward-order card-font-color">My Reward Order</h2>
                        </div>
                        <div className="menu-cart-list mt-4">
                          <MenuCart grid_layout={_location.layout} _location={_location} toggleCart={this.props.toggleCart} />
                        </div>
                        <div>
                          <Link
                            to={`/${_location.slug}/confirm`}
                            className={'clickable-checkout-section '}
                          >
                            <Button className="col mr-1 branding-btn border-0  float-end">
                              {' '}
                              Checkout
                            </Button>
                          </Link>
                        </div>
                      </React.Fragment>


                    </div>
                  </div>
                ) :
                  <div className="cart-list-col reward-cart-empty">

                    <div className="card cart-list border-0" >
                      <React.Fragment>
                        <div className='d-flex justify-content-center' >
                          <h2 className="f3 card-font-color">Your basket is empty.</h2>
                        </div>
                        <div>
                          <Link
                            to={`/${_location.slug}/confirm`}
                            className={'clickable-checkout-section '}
                          >
                            <Button className="col mr-1 branding-btn border-0  float-end">
                              {' '}
                              Checkout
                            </Button>
                          </Link>
                        </div>
                      </React.Fragment>


                    </div>
                  </div>
              }

            </div>


          </div>
          <div className="hamburger-menu-data" ref={this.sidebarRef}>
            <div id="overlay" onClick={this.closeSidebar.bind(this)}></div>
            <ul className={'sidebar-menu-data primary-color'}>
              <li className={'hamburger-close'}>
                <div className="hamburger-close__close card-color" onClick={this.closeSidebar.bind(this)}>
                  <FontAwesomeIcon size={'lg'} color="var(--card-subtitle-color)" icon={faBars} />
                </div>
              </li>
              {LoginService.getToken() !== null ? (
                <>
                  <li onClick={this.showNotification.bind(this)}>
                    <h3>Notifications</h3>{' '}
                    <FontAwesomeIcon color="var(--primary-font-color)" size={'lg'} icon={faBell} />
                  </li>
                  <li onClick={this.myOrderSidebar.bind(this)}>
                    <h3>My Orders</h3>{' '}
                    <FontAwesomeIcon
                      color="var(--primary-font-color)"
                      size={'sm'}
                      icon={faShoppingBag}
                    />
                  </li>
                  <li onClick={this.myRewardSidebar.bind(this)}>
                    <h3>Quests</h3>{' '}
                    <FontAwesomeIcon
                      color="var(--primary-font-color)"
                      size={'sm'}
                      icon={faHeart}
                    />
                  </li>
                  <li onClick={this.myRewardWalletSidebar.bind(this)}>
                    <h3>Rewards</h3>{' '}
                    <FontAwesomeIcon
                      color="var(--primary-font-color)"
                      size={'sm'}
                      icon={faStar}
                    />
                  </li>
                  <li onClick={this.openSidebarOther.bind(this)}>
                    <h3>Others</h3>{' '}
                    <FontAwesomeIcon color="var(--primary-font-color)" size={'sm'} icon={faCog} />
                  </li>
                  <li onClick={this.logOut.bind(this)}>
                    <h3>Logout</h3>{' '}
                    <FontAwesomeIcon color="var(--primary-font-color)" size={'sm'} icon={faPowerOff} />
                  </li>
                </>
              ) : this.props.loc_pathname !== 'confirm' ? (
                <>
                  <li onClick={this.toggleLoginModal.bind(this)}>
                    <h3>Login</h3> <LogoutIcon color="var(--primary-font-color)" />
                  </li>
                  <li onClick={this.myRewardSidebar.bind(this)}>
                    <h3>Quests</h3>{' '}
                    <FontAwesomeIcon
                      color="var(--primary-font-color)"
                      size={'sm'}
                      icon={faHeart}
                    />
                  </li>
                  <li>
                    <a className='d-flex' href={`${_location.domain_url}/sitemap.xml`} target="_blank" rel="noopener noreferrer" style={{ columnGap: '15px' }}>
                      <h3>Sitemap</h3>{' '}
                      <FontAwesomeIcon color="var(--primary-font-color)" size={'sm'} icon={faLink} />
                    </a>
                  </li>
                </>
              ) : (
                <>
                  <li onClick={this.closeSidebar.bind(this)}>
                    <h3>Login</h3> <LogoutIcon color="var(--primary-color)" />
                  </li>
                  <li onClick={this.myRewardSidebar.bind(this)}>
                    <h3>Quests</h3>{' '}
                    <FontAwesomeIcon
                      color="var(--primary-font-color)"
                      size={'sm'}
                      icon={faHeart}
                    />
                  </li>
                  <li>
                    <a className='d-flex' href={`${_location.domain_url}/sitemap.xml`} target="_blank" rel="noopener noreferrer" style={{ columnGap: '15px' }}>
                      <h3>Sitemap</h3>{' '}
                      <FontAwesomeIcon color="var(--primary-font-color)" size={'sm'} icon={faLink} />
                    </a>
                  </li>
                </>
              )}
            </ul>
            <ul className={'sidebar-menu-data-other primary-color'}>
              <li className={'hamburger-close'}>
                <div className="hamburger-close__close card-color" onClick={this.closeSidebarOther.bind(this)}>
                  <FontAwesomeIcon className="" color="var(--card-subtitle-color)" size={'sm'} icon={faArrowRight} />
                </div>
              </li>
              {LoginService.getToken() !== null ? (
                <>
                  <li onClick={this.openTerms.bind(this)}>
                    <h3>Terms & Conditions</h3>{' '}
                    <FontAwesomeIcon color="var(--primary-font-color)" size={'sm'} icon={faInfoCircle} />
                  </li>
                  <li onClick={this.openAccModal.bind(this)}>
                    <h3>Account Deletion</h3>{' '}
                    <FontAwesomeIcon color="var(--primary-font-color)" size={'sm'} icon={faUser} />
                  </li>
                  {_location?.sitemap ?
                    <li>
                      <a className='d-flex' href={`${_location.domain_url}/sitemap.xml`} target="_blank" rel="noopener noreferrer" style={{ columnGap: '15px' }}>
                        <h3>Sitemap</h3>{' '}
                        <FontAwesomeIcon color="var(--primary-font-color)" size={'sm'} icon={faLink} />
                      </a>
                    </li>
                    : ''}
                </>
              ) : this.props.loc_pathname !== 'confirm' ? (
                <li onClick={this.toggleLoginModal.bind(this)}>
                  <h3>Login</h3> <LogoutIcon color="var(--primary-font-color)" />
                </li>
              ) : (
                <li onClick={this.closeSidebar.bind(this)}>
                  <h3>Login</h3> <LogoutIcon color="var(--primary-font-color)" />
                </li>
              )}
            </ul>
            <ul className="sidebar-menu-notification-data card-color" ref={this.notificationRef}>
              <li className={'hamburger-close'}>
                <div className="hamburger-close__close card-color" onClick={this.closeNotification.bind(this)}>
                  <FontAwesomeIcon size={'lg'} color="var(--card-subtitle-color)" icon={faBars} />
                </div>
              </li>
              {LoginService.getToken() !== null &&
                this.props?.notifications?.length > 0 &&
                this.props?.notifications?.map((notification) => {
                  let order = notification.Order;
                  let dateTime;
                  if (order) {
                    dateTime = TimeHelper.getLocalDateTimeFromUTCString(
                      `${order.order_date} ${order.order_time}`
                    );
                    dateTime = TimeHelper.formattedDateTime(dateTime);
                  }
                  return (
                    <li
                      onClick={() => this.onReviewClick(notification)}
                      style={{ cursor: 'pointer' }}
                    >
                      <h3 className='highlight-color-active'>{notification.Location.name}</h3>
                      <h4 className='card-font-color'
                        dangerouslySetInnerHTML={{
                          __html: CONSTANTS.NOTIFICATIONS.VARIABLES.TEXTS[notification.type](
                            notification.Location.name
                          )
                        }}
                      ></h4>
                      <h5 className='card-font-color'>{dateTime}</h5>
                    </li>
                  );
                })}
            </ul>
          </div>
          <CustomLogin
            _location={_location}
            isLogin={true}
            showModal={this.state.showLoginModal}
            toggleModal={this.toggleLoginModal.bind(this)}
            onLoginSuccess={this.onLoginCallback.bind(this, true)}
            onLoginFailed={this.onLoginCallback.bind(this, false)}
          />
        </React.Fragment >
      );
    }
  }
}

function mapStateToProps(state) {
  const {
    location,
    cart,
    promotions,
    locationSettings,
    childLocations,
    toast,
    error,
    categories,
    notifications
  } = state;
  const promotionTitles =
    promotions && location ? ViewHelper.getPromotionTitles(promotions, location) : [];
  return {
    _location: location,
    cart,
    promotions,
    locationSettings,
    promotionTitles,
    error,
    toast: toast?.toast,
    outlets: childLocations,
    categories,
    notifications
  };
}

export default connect(mapStateToProps, {
  getOutlets,
  getLocation,
  setLocation,
  updateCart,
  getPromotions,
  getLocationLayoutSettings,
  getPaymentProcessor,
  getCategories,
  getLoyalties,
  getNotifications,
  getToastSettings: alerts.getToastSettings
})(withBackButtonHandled(Banner, (props) => { }));
